import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import Layout from "../components/Layout/Layout";
import Slider from "../components/Slider";
import {
  collection,
  getCountFromServer,
  where,
  query,
} from "firebase/firestore";
import { db } from "../firebase.config";

const HomePage = () => {
  const tit = require("./house.png");
  const navigate = useNavigate();
  const img1 =
    "https://images.unsplash.com/photo-1490197415175-074fd86b1fcc?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1474&q=80";
  const img2 =
    "https://images.unsplash.com/photo-1583608205776-bfd35f0d9f83?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80";
  const img3 =
    "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80";
  const img4 = "https://www.vhv.rs/file/max/19/190189_orange-box-png.png";

  const [rent, setRent] = useState();
  const [sale, setSale] = useState();
  const [lease, setLease] = useState();
  const [user, setUser] = useState();

  useEffect(() => {
    const fetchListing = async () => {
      try {
        const listingRef = collection(db, "listing");

        const q1 = query(listingRef, where("type", "==", "lease"));
        const querySnap1 = await getCountFromServer(q1);
        setLease(querySnap1.data().count);

        const q2 = query(listingRef, where("type", "==", "rent"));
        const querySnap2 = await getCountFromServer(q2);
        setRent(querySnap2.data().count);

        const q3 = query(listingRef, where("type", "==", "sale"));
        const querySnap3 = await getCountFromServer(q3);
        setSale(querySnap3.data().count);

        const userRef = collection(db, "users");
        const usersnap = await getCountFromServer(userRef);
        setUser(usersnap.data().count);
      } catch (error) {
        console.log("Something Went Wrong");
      }
    };

    fetchListing();
  }, []);

  return (
    <Layout>
      <div className="mainh row">
        <img src={tit} alt="bg"></img>
        <div className="maintext col-md-8">
          <h1>
            griha<span>pravesh</span>
          </h1>
          <h6>GET THE HOME OF YOUR DREAMS</h6>
        </div>
        <div className="col-md-2 mainbtn">
          <Link to="/profile">
            <button className="btn btn-lg btn-primary">Your Profile</button>
          </Link>
        </div>
      </div>

      <br />
      <br />

      <div className="container mt-4">
        <div className="container text-dark mt-4 p-2">
          <h1>Categories</h1>
          <p>Explore According to your needs</p>
        </div>
        <div className="row align-items-center justify-content-center d-flex">
          <div className="col-md-4 catdab">
            <div className="Imagecontainer m-auto img-thumbnail">
              <img src={img1} alt="Rent" style={{ width: "100%" }} />
              <button
                className="btn"
                onClick={() => navigate("/category/rent")}
              >
                To Rent
              </button>
            </div>
          </div>
          <div className="col-md-4 catdab">
            <div className="Imagecontainer m-auto img-thumbnail">
              <img src={img2} alt="Rent" style={{ width: "100%" }} />
              <button
                className="btn"
                onClick={() => navigate("/category/sale")}
              >
                To Sell
              </button>
            </div>
          </div>

          <div className="col-md-4 catdab">
            <div className="Imagecontainer m-auto img-thumbnail">
              <img src={img3} alt="Rent" style={{ width: "100%" }} />
              <button
                className="btn"
                onClick={() => navigate("/category/lease")}
              >
                Lease
              </button>
            </div>
          </div>
        </div>
        <br />
        <br />

        <div className="container mt-4 mb-0 p-2">
          <h1>Recent Listings</h1>
          <p>Latest Properties on GrihaPravesh</p>
        </div>

        <Slider style={{ flex: 1 }} />

        <br />
        <br />

        <div className="container mt-4 mb-0 p-2">
          <h1>Catalogue</h1>
          <p>Everything we have Achieved so far</p>
        </div>
        <div className="row align-items-center justify-content-center d-flex">
          <div className="col-md-3 col-5 catdab">
            <div className="Imagecontainer imgi m-auto">
              <img
                src={img4}
                alt="Rent"
                style={{ width: "100%", filter: "hue-rotate(230deg) grayscale(20%)" }}
              />
              <h6 className="imgh">
                {rent}
                <br /> 
                <span>Rent Properties</span>
              </h6>
            </div>
          </div>

          <div className="col-md-3 col-5 catdab">
            <div className="Imagecontainer imgi m-auto">
              <img
                src={img4}
                alt="Rent"
                style={{ width: "100%", filter: "hue-rotate(215deg) grayscale(15%)" }}
              />
              <h6 className="imgh">
                {sale} <br /> 
                <span>Sale Properties</span>
              </h6>
            </div>
          </div>

          <div className="col-md-3 col-5 catdab">
            <div className="Imagecontainer imgi m-auto">
              <img
                src={img4}
                alt="Rent"
                style={{ width: "100%", filter: "hue-rotate(200deg) grayscale(15%)" }}
              />
              <h6 className="imgh">
                {lease} <br /> 
                <span>Lease Properties</span>
              </h6>
            </div>
          </div>

          <div className="col-md-3 col-5 catdab">
            <div className="Imagecontainer imgi m-auto">
              <img
                src={img4}
                alt="Rent"
                style={{ width: "100%", filter: "grayscale(100%)" }}
              />
              <h6 className="imgh">
                {user} <br/>
                <span>Satisfied Users</span>
              </h6>
            </div>
          </div>
        </div>
        <br />
      </div>

      <div className="container">
        <div className="redcreate">
          <div className="row">
            <div className="col-md-8 ms-4">
              <h2>
                Post your Property for <span className="fre">Free</span>
              </h2>
              <p>List it on GrihaPravesh and get genuine leads</p>
            </div>
            <div className="col-md-3">
              <Link to="/create-listing">
                <button className="btn btn-lg mt-3 btn-primary">
                  Post Property<span>Free</span>
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default HomePage;
